export default __webpack_public_path__ + "static/media/hangers.b2ab5bc9.png";